// document.addEventListener('DOMContentLoaded', () => {
//     const elements = document.querySelectorAll('.btn-nav');

//     elements.forEach(element => {
//         element.addEventListener('mouseover', () => {
//             if (element.tagName.toLowerCase() === 'button') {
//                 (element as HTMLButtonElement).click();
//             }

//             // Entferne die Klasse 'pseudo-active' von allen Elementen
//             elements.forEach(el => {
//                 el.classList.remove('pseudo-active');
//             });

//             // Füge die Klasse 'pseudo-active' dem aktuellen Element hinzu
//             element.classList.add('pseudo-active');
//         });
//     });
// });

document.addEventListener('DOMContentLoaded', () => {
    const links = document.querySelectorAll('.nav-link');
  
    links.forEach((link) => {
      link.addEventListener('click', (event: MouseEvent) => {
        const anchor = event.target as HTMLAnchorElement;
        const href = anchor.getAttribute('href') || '';
  
        // Get the current page path
        const currentPath = window.location.pathname;
  
        // Check if it's an anchor link (i.e., has a hash part)
        const isAnchorLink = href.includes('#');
  
        // If it's a hash (anchor link) and pointing to the current page (same URL path)
        if (isAnchorLink && href.startsWith(currentPath)) {
          // Prevent the default behavior (e.g., jumping)
          // event.preventDefault();
          // // Extract the fragment identifier (e.g., #section1 or #c68)
          // const fragment = href.split('#')[1];
  
          // // Check if the fragment is valid
          // if (fragment) {
          //   // Use the fragment part only for querySelector
          //   const targetElement = document.querySelector(`#${fragment}`);
          //   if (targetElement) {
          //     // Smooth scroll to the target element
          //     targetElement.scrollIntoView({ behavior: 'smooth' });
          //   }
          // }
  
          // Simulate closing the off-canvas menu
          const closeButton = document.querySelector('.btn-close[data-bs-target="#offcanvasNavbar"]');
          if (closeButton) {
            closeButton.click();
          }
        }
      });
    });
  });
  